import { r as registerInstance, h, F as Fragment, g as getElement } from './index-16dc7dde.js';
import { n as EEvent } from './request.constants-deb285e0.js';
import { g as getMyProductsFromConnector } from './utils-62e3520b.js';
import { c as comparator } from './comparator-188d64f5.js';
import { ac as DEFAULT_CATEGORY_PRODUCT_CTAS, a8 as parseRichText, a as isMobile, y as isBrowser, aw as getCategoryOrSubCatFilterUrl, a1 as setPaginationParams, a0 as filterReset, a2 as trackFilterAnalytics, a3 as setNavigationFilterPath, w as getQueryParam, a9 as getBaseUrl, ab as pageParam, ak as listingTypes, a4 as getPaginationParams, N as NAVIGATION_STATE_PARAM_NAME, a5 as fetchSprykerFilters, a7 as getFilterProductsUrl, a6 as getPbsFilterProductsUrl, g as getData, ax as getCategoryRangesFilterUrl, ay as getPbsRangesfiltersUrl, al as MAX_RANGES_BEFORE_SDL_PROMO_BANNER, am as MAX_VISIBLE_CARDS_WHILE_COLLAPSED } from './utils-15ad90ec.js';
import { c as classnames } from './index-136476ff.js';
import { F as FILTER_STATE_CHANGED_EVENT_NAME } from './analytics-765d4daf.js';
import { u as useReplatformedHMC } from './lookups-705fb53e.js';
import './noop-9247c8ef.js';
import './promise-74c80706.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_commonjsHelpers-ba3f0406.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const pesCategorySubcategoryProductsListCss = ":host{display:block}@media screen and (min-width: 980px){.products-list__list{display:block}}.products-list__title{color:#333333;margin:0;font-weight:normal;font-size:1.125rem;line-height:1.5625rem}@media screen and (min-width: 980px){.products-list__title{font-size:1.375rem;line-height:1.875rem}}.products-list__count{color:#9fa0a4}";

let PesCategorySubcategoryProductsList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productCtas = DEFAULT_CATEGORY_PRODUCT_CTAS;
    this.isProductsLoading = false;
    this.parsedProducts = null;
    this.showCompare = true;
    this.isPBS = false;
    this.enableAppRouting = false;
    this.comparatorValue = comparator.value;
    this.productsIds = [];
    this.productsCount = 0;
    this.handleComparatorChange = (e) => {
      this.comparatorValue = e.detail;
    };
    this.handleProductCtasChange = (event) => {
      if (!this.productCtas)
        return;
      if (this.isPBS) {
        this.productCtas = Object.assign({}, this.productCtas);
        return;
      }
      this.productCtas = Object.assign(Object.assign({}, this.productCtas), { buttons: event.detail });
    };
    this.el.dir = (document === null || document === void 0 ? void 0 : document.documentElement.dir) || 'auto';
  }
  componentWillLoad() {
    this.setProductsInfo(this.parsedProducts);
  }
  connectedCallback() {
    window === null || window === void 0 ? void 0 : window.addEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  disconnectedCallback() {
    window === null || window === void 0 ? void 0 : window.removeEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  onParsedProductsChange(newProducts) {
    this.setProductsInfo(newProducts);
  }
  setScrollToProduct(event) {
    this.scrollToProduct = event.detail;
  }
  setProductsInfo(productsInfo) {
    if (!productsInfo)
      return;
    const { totalNumRecs, firstRecNum, recsPerPage, productIds, richText } = productsInfo;
    const productsCount = productIds.length;
    this.richText = parseRichText(richText);
    const lastRecNum = firstRecNum + productsCount - 1;
    this.productsCount = productsInfo.totalNumRecs;
    this.resultsCount = {
      firstRecNum,
      lastRecNum,
      recsPerPage,
      totalNumRecs,
    };
    if (!isMobile()) {
      this.firstLoadedRecNum = undefined;
      this.lastLoadedRecNum = undefined;
      this.productsIds = [];
    }
    this.firstLoadedRecNum = this.firstLoadedRecNum === undefined
      ? firstRecNum
      : Math.min(firstRecNum, this.firstLoadedRecNum);
    this.lastLoadedRecNum = this.lastLoadedRecNum === undefined
      ? lastRecNum
      : Math.max(lastRecNum, this.lastLoadedRecNum);
    this.productsIds = productIds;
  }
  getAdditionalMainQueryParams() {
    return { nodeOrSubCatId: this.navigationState, isCategoryListing: true };
  }
  renderProductCards() {
    var _a, _b, _c;
    if (this.isProductsLoading || this.productsIds.length) {
      return (h("product-cards-wrapper", { class: "products-list__list", showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, comparator: this.comparatorValue, enableCommerceConnector: this.enableCommerceConnector, "product-ids": this.productsIds.join(), host: this.hostWithLocale, additionalMainQueryParams: this.getAdditionalMainQueryParams(), productCtas: this.productCtas, productOfProductsLabel: this.numberProductsOfAllProductsLabel, productsLabel: this.appProductsLabel, firstRecNum: (_a = this.resultsCount) === null || _a === void 0 ? void 0 : _a.firstRecNum, lastRecNum: (_b = this.resultsCount) === null || _b === void 0 ? void 0 : _b.lastRecNum, totalNumRecs: (_c = this.resultsCount) === null || _c === void 0 ? void 0 : _c.totalNumRecs, areListGridLabelsShown: false, scrollToProduct: this.scrollToProduct, enableAppRouting: this.enableAppRouting, localeCode: this.localeCode }, this.productsSectionTitleLabel && (h("div", { slot: "title" }, h("h3", { class: "products-list__title" }, this.productsSectionTitleLabel, h("span", { class: "products-list__count" }, " (", this.productsCount, ") ")))), h("div", { slot: "pills" }, h("pes-range-filter-pills", { pills: this.pills }))));
    }
  }
  renderNoResults() {
    return (h(Fragment, null, h("pes-range-filter-pills", { pills: this.pills }), h("pes-filters-no-results", { noResultsClearLink: this.noResultsClearLinkLabel, noResultsHeader: this.noResultsHeaderLabel, noResultsMessage: this.noResultsMessageLabel })));
  }
  render() {
    var _a, _b;
    if (!this.isProductsLoading && !this.productsIds.length && !((_a = this.richText) === null || _a === void 0 ? void 0 : _a.length)) {
      return this.renderNoResults();
    }
    return (h(Fragment, null, h("pes-range-product-ctas-updater", { buttons: (_b = this.productCtas) === null || _b === void 0 ? void 0 : _b.buttons, myProductsGetter: getMyProductsFromConnector, onButtonsChange: this.handleProductCtasChange }), h("pes-products-pagination", { firstLoadedRecNum: this.firstLoadedRecNum, lastLoadedRecNum: this.lastLoadedRecNum, totalNumRecs: this.productsCount, productsPerPage: this.productsPerPage, showMobilePagination: this.isMobileView && this.isMobileCategorySelected, showDesktopPagination: !this.isMobileView, selectedPage: this.selectedPage, loadMoreLabel: this.loadMoreLabel, loadPreviousLabel: this.loadPreviousLabel, previousLabel: this.previousLabel, nextLabel: this.nextLabel, labelValue: this.labelValue, productsCountLabel: this.productsCountLabel }, this.richText && h("pes-rich-text-information", { richText: this.richText }), this.renderProductCards())));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "parsedProducts": ["onParsedProductsChange"]
  }; }
};
PesCategorySubcategoryProductsList.style = pesCategorySubcategoryProductsListCss;

const pesSprykerCategorySubcategoryListingCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}:host{display:block;box-sizing:border-box;width:100%}:host *,:host *::before,:host *::after{box-sizing:inherit}.category-subcategory-listing{position:relative;display:block;margin:0 auto;box-sizing:border-box;max-width:1200px;overflow:visible;color:#626469;padding-bottom:0;display:flex;flex-direction:column}.category-subcategory-listing *,.category-subcategory-listing *::before,.category-subcategory-listing *::after{box-sizing:inherit}@media screen and (min-width: 980px){.category-subcategory-listing{flex-direction:row}}.category-subcategory-listing__filters{display:flex;flex-direction:column-reverse}@media screen and (min-width: 980px){.category-subcategory-listing__filters{flex-direction:column;flex:0 0 280px}:host(:not([dir=\"rtl\"])) .category-subcategory-listing__filters{margin-right:20px;margin-left:10px}:host([dir=\"rtl\"]) .category-subcategory-listing__filters{margin-left:20px;margin-right:10px}}@media screen and (min-width: 980px){.category-subcategory-listing__content{padding:0;flex:1 1 auto}}@media screen and (min-width: 980px){.category-subcategory-listing__content.category-subcategory-listing__content--with-subcategory{margin-top:40px}}.category-subcategory-listing__products--hidden{display:none}@media screen and (max-width: 719px){.category-subcategory-listing__products{padding-left:16px;padding-right:16px}}.category-subcategory-listing__hmc-banner{margin-bottom:16px}@media screen and (max-width: 719px){.category-subcategory-listing__hmc-banner{padding-left:16px;padding-right:16px}}@media screen and (min-width: 980px){.category-subcategory-listing__hmc-banner{margin-top:12px}.category-subcategory-listing__hmc-banner--top{margin-top:0}}.hidden-subcategories{display:none}.category-subcategory-listing__overlay{z-index:2;top:0;right:0;bottom:0;left:0;background:#fafafa;opacity:0.4}.category-subcategory-listing__overlay:not(.category-subcategory-listing__overlay--visible){display:none}@media screen and (max-width: 979px){.category-subcategory-listing__overlay{position:fixed}}@media screen and (min-width: 980px){.category-subcategory-listing__overlay{position:absolute}}";

let PesSprykerCategorySubcategoryListing = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = '';
    this.hideHMCBanner = false;
    this.navigationState = '';
    this.showBuyOnline = true;
    this.enableCommerceConnector = true;
    this.avoidAccents = false;
    this.isBrowser = isBrowser();
    this.showCompare = true;
    this.searchParams = {};
    this.isSubcategoryPage = false;
    this.isPBS = false;
    this.productCtas = DEFAULT_CATEGORY_PRODUCT_CTAS;
    this.isMobileView = isMobile();
    this.isFilterInMobileViewVisible = false;
    this.isMobileCategorySelected = Boolean(this.navigationState);
    this.isProductsLoading = false;
    this.sprykerParsedProducts = null;
    this.initialNavState = '';
    this.currentNavState = this.navigationState;
    this.isLoadingFilters = false;
    this.PBSoffset = 0;
    this.renderHMC = () => {
      if (this.hideHMCBanner || !this.hmcBanner) {
        return;
      }
      return (h("pes-hmc-banner", { class: {
          'category-subcategory-listing__hmc-banner': true,
          'category-subcategory-listing__hmc-banner--top': this.showHMConTop,
        }, categoryName: this.hmcBanner.categoryName, labels: this.hmcBanner.labels, sourceId: useReplatformedHMC() ? this.hmcBanner.pimId : this.hmcBanner.sourceId, parentCategoryId: this.hmcBanner.parentCategoryId, categoryProductConfiguratorUrl: this.hmcBanner.categoryProductConfiguratorUrl, hasQuestionnaire: this.hmcBanner.hasQuestionnaire, questionnaireUrl: this.hmcBanner.questionnaireUrl, rangeTooltipUrl: this.hmcBanner.rangeTooltipUrl, selectorConfigUrl: this.hmcBanner.selectorConfigUrl, isExternalProductConfiguratorUrl: this.hmcBanner.isExternalProductConfiguratorUrl, isPBS: this.isPBS, variant: "square" }));
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
    this.selectedPage = Math.floor(offset / productsPerPage) + 1;
    this.initialFilterUrl = this.initialBaseFiltersUrl;
    this.subCategoryProductListingParams = {
      pageParam: this.pageParam,
      subCategoryId: this.navigationState,
    };
    const filter = this.getSearchParam() || '';
    this.selectedFilterUrl = getCategoryOrSubCatFilterUrl(this.filtersUrl, this.localeCode, this.subCategoryProductListingParams, filter);
    if (this.isBrowser) {
      this.loadData(this.selectedFilterUrl, true);
    }
  }
  windowSizeDidChange() {
    this.isMobileView = isMobile();
    if (!this.isMobileView && this.isFilterInMobileViewVisible) {
      this.isFilterInMobileViewVisible = false;
    }
  }
  choosePage(event) {
    this.selectedPage = event.detail;
    const { productsPerPage } = this.getPaginationParamsWithDefaults;
    if (!this.isPBS) {
      setPaginationParams(productsPerPage * (this.selectedPage - 1), productsPerPage, true);
    }
    this.PBSoffset = productsPerPage * (this.selectedPage - 1);
    this.loadProducts(this.selectedFilterUrl);
  }
  onToggleFilterMobileViewVisibility() {
    this.isFilterInMobileViewVisible = !this.isFilterInMobileViewVisible;
  }
  onSelectCategoryHandler(event) {
    console.log('event.detail', event.detail);
    this.loadData(event.detail);
    this.isMobileCategorySelected = true;
  }
  mobileCategoryReset() {
    this.isMobileCategorySelected = false;
  }
  onFilterStateChanged(event) {
    const { lastChangedFilterId: filterId } = event.detail;
    if (filterId) {
      const { checkedURL, unCheckedURL } = this.filtersNormalized.entities.filter[filterId];
      const changedFilterUrl = unCheckedURL !== '' ? unCheckedURL : checkedURL;
      this.changeFilter(changedFilterUrl, filterReset(changedFilterUrl, this.initialFilterUrl), '');
    }
  }
  removePillHandler(event) {
    const unCheckedURL = event.detail;
    this.changeFilter(unCheckedURL, filterReset(unCheckedURL, this.initialFilterUrl));
  }
  resetAllFiltersHandler() {
    this.changeFilter(this.initialFilterUrl, true);
  }
  handlePopState() {
    if (!this.isPBS) {
      const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
      this.selectedPage = Math.floor(offset / productsPerPage) + 1;
      this.loadData(getCategoryOrSubCatFilterUrl(this.filtersUrl, this.localeCode, this.subCategoryProductListingParams));
    }
  }
  trackAnalyticsEventListener(e) {
    const { event } = e.detail;
    if (!event)
      return;
    if (event === FILTER_STATE_CHANGED_EVENT_NAME)
      trackFilterAnalytics(e, this.filtersNormalized);
  }
  changeFilter(changedFilterUrl, isReset, seoUrl) {
    if (!this.isPBS) {
      setNavigationFilterPath(changedFilterUrl, this.navigationState, isReset, seoUrl);
    }
    this.PBSoffset = 0;
    this.selectedPage = 1;
    this.selectedFilterUrl = changedFilterUrl;
    this.loadData(changedFilterUrl);
  }
  buildSearchParam(param) {
    return param in this.searchParams ? this.searchParams[param] : '';
  }
  getSearchParam(param = 'filter') {
    return this.isPBS ? this.buildSearchParam(param) : getQueryParam(param);
  }
  get hasProducts() {
    var _a;
    return !((_a = this.subcategorySection) === null || _a === void 0 ? void 0 : _a.hideProducts);
  }
  get showHMConTop() {
    return !this.hasProducts && !this.isMobileView;
  }
  get initialBaseFiltersUrl() {
    const categoriesFiltersBaseUrl = getBaseUrl(this.filtersUrl, this.localeCode);
    const subCategoriesBaseUrl = `${getBaseUrl(this.filtersUrl, this.localeCode)}&subcategory-id=${this.navigationState}&pageParam=${pageParam.SUBCATEGORY_LISTING}`;
    return this.pageParam === listingTypes.SUBCATEGORY_LISTING
      ? subCategoriesBaseUrl
      : categoriesFiltersBaseUrl;
  }
  get hasSubcategory() {
    var _a;
    return !!((_a = this.subcategorySection) === null || _a === void 0 ? void 0 : _a.subcategory);
  }
  get getPaginationParamsWithDefaults() {
    return getPaginationParams({
      offset: 0,
      productsPerPage: Number(this.numberOfProducts),
    });
  }
  async loadData(filterUrl, isInitialLoad = false) {
    const searchParams = new URLSearchParams(window.location.search);
    this.loadFilters(`${this.host}${filterUrl}`);
    if (!isInitialLoad || searchParams.has(NAVIGATION_STATE_PARAM_NAME)) {
      await this.loadRanges(filterUrl);
    }
    if (this.hasProducts) {
      this.loadProducts(filterUrl);
    }
  }
  async loadFilters(filterUrl) {
    try {
      this.isLoadingFilters = true;
      const { filtersNormalized, filtrationSmartData, pills, filtersCategories, selectedSectionsCount, } = await fetchSprykerFilters(filterUrl);
      this.filtersNormalized = filtersNormalized;
      this.filtrationSmartData = filtrationSmartData;
      this.pills = pills !== null && pills !== void 0 ? pills : [];
      this.filtersCategories = filtersCategories;
      this.selectedSectionsCount = selectedSectionsCount > 0 ? selectedSectionsCount : 0;
    }
    catch (error) {
      console.error(error);
    }
    finally {
      this.isLoadingFilters = false;
    }
  }
  loadProducts(filtersUrl) {
    this.isProductsLoading = true;
    const PPWProductFiltersUrl = getFilterProductsUrl(this.productsUrl, this.numberOfProducts, this.localeCode, '', this.subCategoryProductListingParams);
    const PBSProductFiltersUrl = getPbsFilterProductsUrl({
      host: this.host,
      ProductsPath: this.productsUrl,
      CheckedFiltersUrl: filtersUrl,
      pbsOffset: this.PBSoffset,
      Nrpp: this.numberOfProducts,
    });
    const url = !this.isPBS ? PPWProductFiltersUrl : PBSProductFiltersUrl;
    getData(false, url)
      .then((response) => {
      const { totalNumRecs } = response;
      this.sprykerParsedProducts = response;
      this.productsCount = totalNumRecs;
    })
      .finally(() => {
      this.isProductsLoading = false;
    });
  }
  async loadRanges(filtersUrl) {
    const PPWRangesFiltersUrl = getCategoryRangesFilterUrl(this.rangesUrl, this.localeCode, this.subCategoryProductListingParams);
    const PBSRangesFiltersUrl = getPbsRangesfiltersUrl({
      host: this.host,
      rangesPath: this.rangesUrl,
      CheckedFiltersUrl: filtersUrl,
    });
    const url = !this.isPBS ? PPWRangesFiltersUrl : PBSRangesFiltersUrl;
    const response = await getData(false, url);
    if (this.pageParam === listingTypes.SUBCATEGORY_LISTING && response.subcategory) {
      response.subcategory.name = null;
      response.subcategory.description = null;
    }
    this.subcategorySection = response;
  }
  renderFilters() {
    if (!this.filtrationSmartData) {
      return;
    }
    return (h("pes-responsive-filters", { filtrationSmartData: this.filtrationSmartData, resetButtonLabel: this.filtersSection.labels.facetButtonResetAll, viewMoreFacetsLabel: this.filtersSection.labels.facetButtonViewMoreFilters, viewLessFacetsLabel: this.filtersSection.labels.facetButtonViewLessFilters, headerLabelDesktop: this.filtersSection.labels.commonFiltersFilterBy, headerLabelMobile: this.filtersSection.labels.rangeProductsFilters, viewProductsLabel: this.filtersSection.labels.viewProducts, viewMoreRefinementsLabel: this.filtersSection.labels.viewMore, viewLessRefinementsLabel: this.filtersSection.labels.viewLess, noProductsFoundLabel: this.filtersSection.labels.noProductsFound, isMobileViewVisible: this.isFilterInMobileViewVisible, isMobileCategorySelected: this.isMobileCategorySelected, selectedSectionsCount: this.selectedSectionsCount, productsCount: this.productsCount, categories: this.filtersCategories, onShowMobileFilter: () => (this.isFilterInMobileViewVisible = true) }));
  }
  renderSubcategoryBlock() {
    const { labels, subcategory, sdlPromoBlocks, productTypeFilterSelected } = this.subcategorySection;
    if (sdlPromoBlocks) {
      return h("pes-subcategory-promo-blocks", { subcategoryPromoBlocksData: sdlPromoBlocks });
    }
    if (this.hasSubcategory) {
      return (h("pes-subcategory-list", null, h("pes-subcategory-block", { slot: "pes-subcategory-block", subCategory: subcategory, rangePartofLabel: labels.rangePartofLabel, viewOnLabel: labels.viewOnLabel, productRelationsViewProdLabel: labels.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: labels.rangeProductsViewDetailsLabel, readMoreLabel: labels.readMoreLabel, readLessLabel: labels.readLessLabel, rangesSectionTitleLabel: labels.rangesSectionTitle, viewMoreLabel: labels.viewMore, viewLessLabel: labels.viewLess, rangeBlockCollapsible: this.hasProducts, showDescriptionBlock: !this.isSubcategoryPage && productTypeFilterSelected, avoidAccents: this.avoidAccents, navState: this.currentNavState })));
    }
    return null;
  }
  getHiddenSubcategories() {
    var _a;
    const { subcategory, sdlPromoBlocks } = this.subcategorySection;
    if (!((_a = this.hiddenSubcategoriesInfo) === null || _a === void 0 ? void 0 : _a.length)) {
      return [];
    }
    if (sdlPromoBlocks || !subcategory) {
      return this.hiddenSubcategoriesInfo;
    }
    const { sdlCategoryPromo } = subcategory;
    const visibleRanges = subcategory.ranges.slice(0, sdlCategoryPromo ? MAX_RANGES_BEFORE_SDL_PROMO_BANNER : MAX_VISIBLE_CARDS_WHILE_COLLAPSED);
    const visibleRangesIDs = visibleRanges.map((range) => range.id);
    return this.hiddenSubcategoriesInfo.reduce((accCategories, subCategories) => {
      const category = Object.assign(Object.assign({}, subCategories), { ranges: subCategories.ranges.filter((range) => {
          return !visibleRangesIDs.includes(range.id);
        }) });
      if (category.ranges.length > 0) {
        accCategories.push(category);
      }
      return accCategories;
    }, []);
  }
  renderHiddenSubcategories() {
    const subCategories = this.getHiddenSubcategories();
    if (!subCategories.length) {
      return null;
    }
    const { labels } = this.subcategorySection;
    return (h("pes-subcategory-list", { class: "hidden-subcategories" }, subCategories.map((subCategory) => (h("pes-subcategory-block", { slot: "pes-subcategory-block", subCategory: subCategory, rangePartofLabel: labels.rangePartofLabel, viewOnLabel: labels.viewOnLabel, productRelationsViewProdLabel: labels.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: labels.rangeProductsViewDetailsLabel, readMoreLabel: labels.readMoreLabel, readLessLabel: labels.readLessLabel, rangesSectionTitleLabel: labels.rangesSectionTitle, viewMoreLabel: labels.viewMore, viewLessLabel: labels.viewLess, rangeBlockCollapsible: false, avoidAccents: this.avoidAccents, navState: this.currentNavState })))));
  }
  renderProducts() {
    var _a;
    if (!this.hasProducts) {
      return null;
    }
    const { productsPerPage } = this.getPaginationParamsWithDefaults;
    const areProductsHidden = this.isMobileView
      && (this.isFilterInMobileViewVisible
        || (!this.isMobileCategorySelected && ((_a = this.filtersCategories) === null || _a === void 0 ? void 0 : _a.length) > 0));
    return (h("pes-category-subcategory-products-list", { class: classnames('category-subcategory-listing__products', {
        'category-subcategory-listing__products--hidden': areProductsHidden,
      }), hostWithLocale: this.isPBS ? this.host : this.localeCode, navigationState: this.navigationState, isProductsLoading: this.isProductsLoading, parsedProducts: this.sprykerParsedProducts, selectedPage: this.selectedPage, productsPerPage: productsPerPage, pills: this.pills, isMobileView: this.isMobileView, isMobileCategorySelected: this.isMobileCategorySelected, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, enableCommerceConnector: this.enableCommerceConnector, numberProductsOfAllProductsLabel: this.productsSection.labels.numberProductsOfAllProducts, appProductsLabel: this.productsSection.labels.appProducts, loadMoreLabel: this.productsSection.labels.loadMore, loadPreviousLabel: this.productsSection.labels.loadPrevious, previousLabel: this.productsSection.labels.previous, labelValue: this.productsSection.labels.pageLabel, nextLabel: this.productsSection.labels.next, productsSectionTitleLabel: this.productsSection.labels.title, noResultsClearLinkLabel: this.productsSection.labels.noResultsClearLink, noResultsHeaderLabel: this.productsSection.labels.noResultsHeader, noResultsMessageLabel: this.productsSection.labels.noResultsMessage, enableAppRouting: this.isPBS, localeCode: this.localeCode, isPBS: this.isPBS, productCtas: this.productCtas, showCompare: this.showCompare }));
  }
  render() {
    return (h("main", { class: "category-subcategory-listing" }, h("div", { class: {
        'category-subcategory-listing__overlay': true,
        'category-subcategory-listing__overlay--visible': this.isLoadingFilters,
      } }), h("aside", { class: "category-subcategory-listing__filters" }, this.renderFilters(), !this.showHMConTop && this.renderHMC()), h("section", { class: {
        'category-subcategory-listing__content': true,
        'category-subcategory-listing__content--with-subcategory': this.hasSubcategory,
      } }, this.showHMConTop && this.renderHMC(), this.renderSubcategoryBlock(), this.renderHiddenSubcategories(), this.renderProducts())));
  }
  get el() { return getElement(this); }
};
PesSprykerCategorySubcategoryListing.style = pesSprykerCategorySubcategoryListingCss;

export { PesCategorySubcategoryProductsList as pes_category_subcategory_products_list, PesSprykerCategorySubcategoryListing as pes_spryker_category_subcategory_listing };
